/**
 * Syncs Redux `openedModalId` to Oasis dialog open calls for header modals.
 * @module headerModals/hooks/useHeaderModalOpenEffect
 */

import { useEffect } from "react";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../../enums/modalId";

/** Header modal ids opened via Redux → Oasis bridge. */
const HEADER_MODAL_IDS: ModalId[] = [
  ModalId.FORM_SELECTION_MODAL,
  ModalId.HAPPY_FLOW_MODAL,
  ModalId.COMMENT_RPA_MODAL_NEW,
  ModalId.NAR_RPA_TRIGGER_MODAL,
];

/**
 * Opens the Oasis dialog when Redux `openedModalId` matches a header modal.
 *
 * @param openedModalId - Active modal id from the modal slice
 */
export const useHeaderModalOpenEffect = (
  openedModalId: string | null,
): void => {
  useEffect(() => {
    if (openedModalId == null) {
      return;
    }

    if (HEADER_MODAL_IDS.includes(openedModalId as ModalId)) {
      openModal(openedModalId);
    }
  }, [openedModalId]);
};
